export default "__VITE_ASSET__DlHT4UzK__"